import { isLink } from "../../../common/is-link.js";
import { PseudoClassSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#link-pseudo}
 */
export class AnyLink extends PseudoClassSelector {
    static of() {
        return new AnyLink();
    }
    constructor() {
        super("any-link");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        return isLink(element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (AnyLink) {
    AnyLink.parse = PseudoClassSelector.parseNonFunctional("any-link", AnyLink.of);
})(AnyLink || (AnyLink = {}));
//# sourceMappingURL=any-link.js.map